import { styled } from '../../configs/stitches.config';

export const Container = styled('div', {
  background: '$backgroundSecondary',
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  justifyContent: 'space-between',
});

export const Description = styled('p', {
  font: '$bodyRegular',
});

export const ErrorMessage = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto 120px',
  maxWidth: '410px',
});

export const Image = styled('img', {
  margin: '0 auto',
  width: '214px',
});

export const Title = styled('h1', {
  font: '$headingLgBold',
  marginBottom: '$spacingMd',
  marginTop: '$spacingXl',
});

export const HeaderWrapper = styled('div', {
  maxWidth: '100%',
  padding: '0 $spacingXl',
  maxHeight: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 auto',
});
